// TODO: change type in v4.0
// eslint-disable-next-line no-restricted-syntax
export enum TuiEditorTool {
    Undo = `undo`,
    Anchor = `anchor`,
    Size = `fontSize`,
    Bold = `bold`,
    Italic = `italic`,
    Underline = `underline`,
    Strikethrough = `strikeThrough`,
    Align = `justify`,
    List = `list`,
    Quote = `quote`,
    Color = `foreColor`,
    Hilite = `hiliteColor`,
    Clear = `clear`,
    Link = `link`,
    Attach = `attach`,
    Tex = `tex`, // Todo
    Code = `code`,
    Img = `image`,
    HR = `insertHorizontalRule`,
    Sup = `superscript`,
    Sub = `subscript`,
    Table = `insertTable`,
    MergeCells = `mergeCells`,
    SplitCells = `splitCells`,
    RowsColumnsManaging = `rowsColumnsManaging`,
    Details = `details`,
    Group = `group`,
}
